import { render, staticRenderFns } from "./release_block_milestone_info.vue.js?vue&type=template&id=1da0d769&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./release_block_milestone_info.vue?vue&type=template&id=1da0d769&vue3"
import script from "./release_block_milestone_info.vue.js?vue&type=script&lang=js&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./release_block_milestone_info.vue?vue&type=script&lang=js&vue3"
export * from "./release_block_milestone_info.vue.js?vue&type=script&lang=js&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./release_block_milestone_info.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports